import script from "./TriadTranspose.vue?vue&type=script&setup=true&lang=js"
export * from "./TriadTranspose.vue?vue&type=script&setup=true&lang=js"

import "./TriadTranspose.vue?vue&type=style&index=0&id=7a048d58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a048d58"]])

export default __exports__